import { platformSelect } from '@bubble-ui/util-platform';
export var getDefaultStyleSheet = _ref => {
  var {
    children,
    hasChevron
  } = _ref;
  return {
    rootStyle: {
      flexDirection: 'row',
      flexGrow: 0,
      flexShrink: 0,
      paddingTop: hasChevron && children !== undefined ? platformSelect({
        android: 2,
        default: 0
      }) : 2,
      paddingLeft: 5,
      paddingRight: 5
    },
    chevronWrapperStyle: {
      marginLeft: 5,
      marginRight: -12,
      paddingTop: platformSelect({
        android: 4,
        default: 1
      })
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map